module.exports = __webpack_public_path__ + "assets/online.fb93d2e7.svg";